import React from 'react';
import './App.css';
import AvatarComponent from './components/AvatarComponent';
import LegalDisclaimer from './components/LegalDisclaimer';
import DashboardPage from './components/DashboardPage';
import VersionPage from './components/VersionPage';
import TermsOfServicePage from './components/TermsOfServicePage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import AboutAppPage from './components/AboutAppPage';

const ADMIN_PATHS = new Set([
  '/admin',
  '/dashboard',
  '/conversations',
  '/dashboard/admins',
  '/dashboard/config',
  '/dashboard/feedback',
]);

function App() {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  const normalized =
    pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  if (ADMIN_PATHS.has(normalized)) {
    return <DashboardPage />;
  }
  if (pathname === '/version') return <VersionPage />;
  if (pathname === '/terms') return <TermsOfServicePage />;
  if (pathname === '/privacy') return <PrivacyPolicyPage />;
  if (pathname === '/about-app') return <AboutAppPage />;
  if (pathname === '/terms-of-service') return <TermsOfServicePage />;
  if (pathname === '/privacy-policy') return <PrivacyPolicyPage />;

  return (
    <div className="App">
      <main>
        <AvatarComponent />
      </main>
      <LegalDisclaimer variant="footer" />
    </div>
  );
}

export default App;
